import { FunctionComponent, PropsWithChildren } from 'react'
import { Campaign } from '../../src/types'
import { CampaignContext } from '../../src/state/CampaignContext'
import { Layout } from '../Layout'
import { BorderStack } from '../BorderStack'
import Blurb from '../Blurb'
import { ProductSection } from '../ProductSection'
import CampaignCards from '../CampaignCards'
import Instagrid from '../Instagrid'
import CompanyCards from '../CompanyCards'

export type Props = PropsWithChildren<{
  campaign: Campaign
}>

export const CampaignPage: FunctionComponent<Props> = ({ campaign }) => (
  <CampaignContext.Provider value={campaign}>
    <Layout>
      <BorderStack>
        <Blurb>
          <p>{(campaign.callToActionLarge || campaign.callToAction).trim()}</p>
        </Blurb>
        <ProductSection />
        <CampaignCards />
        <Instagrid images={campaign.instagridImages.slice(0, 4)} />
        <CompanyCards />
      </BorderStack>
    </Layout>
  </CampaignContext.Provider>
)
